import { memo, useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Stack, CircularProgress, TextField, Typography, Card, Breakpoint, CardContent, Button, Box, Grid, RadioGroup, FormControlLabel, FormControl, Radio, Divider} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { actionCreators, selectors } from "../../store";
import useResponsive from "../../hooks/useResponsive";
import { CONTENT_COLOR } from "../../models/Constants";
import { Message } from "../../models/Index";
import { Path as RoutePath } from "../../path";
import FetchHelper from "../FetchHelper";
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import Countdown from "react-countdown";

//#region Props
export type TestFormProps = 
    ReturnType<typeof mapStateToProps> 
    & ReturnType<typeof mapDispatchToProps>
//#endregion

const SAVE_AND_SCORING = "SAVE_AND_SCORING"

const renderer = ({ hours, minutes, seconds, completed }:any) => {
    if (completed) {
        // return <Stack direction={"row"} spacing={1} style={{fontSize:18, fontWeight:"bold", justifyContent:"center", alignItems:"center"}}>
        //         <Stack>
        //             <AccessAlarmIcon sx={{height:"30px"}}/>
        //         </Stack>
        //         <Stack>
        //             --:--:--
        //         </Stack>
        //     </Stack>;
        return <Stack direction={"row"} spacing={1} style={{color: 'red' , fontSize:18, fontWeight:"bold", justifyContent:"center", alignItems:"center"}}>
                <Stack>
                    <AccessAlarmIcon sx={{height:"30px"}}/>
                </Stack>
                <Stack>
                    -{String(hours).padStart(2, '0')}:
                    {String(minutes).padStart(2, '0')}:
                    {String(seconds).padStart(2, '0')}
                </Stack>
            </Stack>;
    } else {
        const isLessThanTenSeconds = hours === 0 && minutes === 0 && seconds <= 0;
        return <Stack direction={"row"} spacing={1} style={{color: isLessThanTenSeconds ? 'red' : 'black', fontSize:18, fontWeight:"bold", justifyContent:"center", alignItems:"center"}}>
                <Stack>
                    <AccessAlarmIcon sx={{height:"30px"}}/>
                </Stack>
                <Stack>
                    {String(hours).padStart(2, '0')}:
                    {String(minutes).padStart(2, '0')}:
                    {String(seconds).padStart(2, '0')}
                </Stack>
            </Stack>;
    }
};

const MemoizedCountdown = memo(({ onComplete }:any) => (
    <Countdown date={Date.now() + 10 * 60 * 1000} renderer={renderer} overtime={true} onComplete={onComplete}/>
));
  
export const TestForm = (props: TestFormProps) => {
    //#region Fields
    const {
        userId,
        userName,
        isAuthorize,
        onSaveAnswer
    } = props;

    const {
       onShowMessage,
    } = props;

    const isDesktop = useResponsive({ query: 'up', key: 'lg' as Breakpoint });
    const isTablet = useResponsive({ query: 'up', key: 'md' as Breakpoint });
    const isMobile= useResponsive({ query: 'up', key: 'sm' as Breakpoint });

    const [loadingFlag, setLoadingFlag] = useState(false);
    const [disableCompleted, setDisableCompleted] = useState(false);
    const [disableClock, setDisableClock] = useState(false);

    const navigate = useNavigate()

    const location = useLocation();

    const data = location.state && location.state?.data;
    const questionId = location.state && location.state?.questionId;

    const [dataList, setDataList] = useState(data.map((item:any) => ({
        ...item,
        isSelected: false,
        isLocked: false,
        answer:3
      })))


    useEffect(() => {
        const handleBeforeUnload = (event:any) => {
            event.preventDefault()
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [navigate]);

    useEffect(() => {
        const handlePopState = (event:any) => {
          event.preventDefault();
          window.history.pushState(null, document.title, window.location.href);
        };
    
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', handlePopState);
    
        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        if(!isAuthorize)
        {
            navigate('/login')
        }
    }, [isAuthorize])

    const handleOnChangeSelect = (event:any, index:any) => {
        const updatedList = dataList.map((item:any,i:any) => {
            if (i == index) {
                item.isSelected = true
                item.answer = Number(event.target.value)
            }
            return item;
        });
        
        setDataList(updatedList);
    }

    const handleEndTest = (isTimeUp:boolean) => {
        if(dataList.find((x:any)=>x.isSelected == false) && !isTimeUp)
        {
            const updatedList = dataList.map((item:any) => {
                if(item.isSelected)
                {
                    item.isLocked = true
                }
                return item
            })
            setDataList(updatedList)
            
            onShowMessage({
                type: "warning",
                title: "未回答あり",
                body: "すべての質問にお答えください",
            })
        }
        else
        {
            setDisableClock(true)
            setDisableCompleted(true)
            setLoadingFlag(true)
            onSaveAnswer({
                userId: userId,
                questionId: questionId,
                data: dataList.map((item:any) => ({
                    "question_id" : item.questionId,
                    "question_no" : item.questionNo,
                    "score_type" : item.scoreType,
                    "answer": item.answer
                })).sort((a:any, b:any) => a.question_no - b.question_no)
            })
        }
    }

    const handleSaveAnswerSuccess = (data:any) => {
        setLoadingFlag(false)
        if(data.resultCode == 0)
        {
            navigate(RoutePath.end)
        }
    }

    const handleSaveAnswerError = (data:any) => {
        setLoadingFlag(false)
        navigate(RoutePath.end)
    }

    return (
        <>
        <div style={{display:"flex", minHeight:"100vh", flexDirection:"column"}}>
            {loadingFlag && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <Stack style={{ height: '100vh', background: '#F9FAFB'}} justifyContent={'flex-start'}>
                <Stack justifyContent="center" alignItems="center" mt={2}>
                    <Card sx={{ width: isDesktop?"75%":"90%", boxShadow: 5, marginTop: 3, marginBottom: 3 }}>
                        <CardContent>
                            <Typography sx={{color:CONTENT_COLOR, fontSize:30, fontWeight:"bold"}}>ストレス耐性テスト</Typography>
                            <Stack direction={"row"} justifyContent={"space-between"}>
                                <Stack direction={"row"} sx={{alignItems:"center"}} spacing={1} marginTop={2} marginLeft={"5px"} width={isDesktop || isTablet? "25%" :"40%"}>
                                    <TextField  
                                        defaultValue={userName}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                            height: '8px',
                                            textAlign:"center",
                                            },
                                            width:"90%",
                                            fontSize:16,
                                        }}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    ></TextField>
                                    <Typography fontSize={16}>様</Typography>
                                </Stack>
                                <Stack direction={"row"} sx={{alignItems:"center"}} spacing={1} marginTop={2} marginLeft={"5px"}  width={isDesktop || isTablet?"20%":"40%"}>
                                    <Box sx={{border:"1px solid #cccccc","&:hover":{border:"1px solid black"}, borderRadius:"8px", width:"100%", height:"39px", alignContent:"center"}}>
                                        <MemoizedCountdown onComplete={useCallback(()=>{},[])} />
                                    </Box>
                                </Stack>
                            </Stack>

                            <Stack direction={"column"} maxHeight={"70vh"} width={"100%"} overflow={"auto"} marginTop={2}>
                                    {
                                        dataList && dataList.map((item:any,index:any)=>{
                                            return(<>
                                            <Grid container direction={"row"} alignItems={"center"} width={"100%"} mt={1} sx={{backgroundColor:item.isSelected ? "#d9d9d9":"#e8f4fe"}}>
                                                <Grid item xs={1}>{'Q' + item.questionNo}</Grid>
                                                <Grid item xs={7.5} sx={{userSelect:"none"}}>{item.content}</Grid>
                                                <Grid item xs={3.5}>
                                                    <RadioGroup
                                                        row={true}
                                                        onChange={(e)=>handleOnChangeSelect(e,index)}
                                                    >
                                                        <FormControlLabel value={"0"} sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: 'black'}}} control={<Radio disabled={item.isLocked? true:false} sx={{'&.Mui-disabled': {color: 'black'}}}/>} label="はい" />
                                                        <FormControlLabel value={"1"} sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: 'black'}}} control={<Radio disabled={item.isLocked? true:false} sx={{'&.Mui-disabled': {color: 'black'}}}/>} label="いいえ" />
                                                        <FormControlLabel value={"2"} sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: 'black'}}} control={<Radio disabled={item.isLocked? true:false} sx={{'&.Mui-disabled': {color: 'black'}}}/>} label="？" />
                                                    </RadioGroup>
                                                </Grid>
                                            </Grid>
                                            <Divider/>
                                            </>)
                                        })
                                    }
                            </Stack>
                            
                            <Stack direction={"row"} justifyContent={"end"} marginTop={2} marginRight={"10px"}>
                                <Button variant="contained" onClick={()=>handleEndTest(false)} disabled={disableCompleted}>提出</Button>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Stack>
        </div>  
        <FetchHelper
            fetchId={SAVE_AND_SCORING}
            onComplete={(success, data, error) =>{
                    success ? handleSaveAnswerSuccess(data) : handleSaveAnswerError(data)
                }
            }
        />
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        userId: state.app.user?.userId,
        userName: state.app.user?.userName,
        isAuthorize: selectors.isAuthorize(state),
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        onShowMessage: (message: Message) => dispatch(actionCreators.showMessage(message)),
        onSaveAnswer:(params:any) =>dispatch(actionCreators.fetch(SAVE_AND_SCORING,'/score/set-answer','POST',params,false,true)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TestForm);
